import { Invoice, PaymentMethod } from '../../types';
import { hasBlockingErrors, openAmountCents, validatePayment } from '../../services/invoiceLogic';

/**
 * Gemeinsames Kleingut der Zahlungserfassung.
 *
 * Eigene Datei und keine Konstante in einer der beiden Masken: die Zahlung
 * laesst sich an zwei Stellen buchen — im Beleg (PaymentsPanel) und aus der
 * Liste heraus (MarkPaidDialog). Was beide brauchen, darf nicht in einer der
 * beiden liegen, sonst zieht der Import die ganze andere Maske mit und die
 * Fast-Refresh-Regel schlaegt an.
 */

/** Beschriftung der Zahlungsarten — an beiden Erfassungswegen dieselbe. */
export const METHOD_LABEL: Record<PaymentMethod, string> = {
    BANK_TRANSFER: 'Überweisung',
    CASH: 'Bar',
    CARD: 'Karte',
    DIRECT_DEBIT: 'Lastschrift',
    OFFSET: 'Verrechnung',
    OTHER: 'Sonstiges',
    CASH_DISCOUNT: 'Skonto',
    CUSTOMER_RETENTION: 'Sicherheitseinbehalt',
};

/**
 * Darf dieser Beleg aus der Liste heraus bezahlt gemeldet werden?
 *
 * Die Statusliste wird bewusst NICHT ein zweites Mal aufgeschrieben, sondern
 * gegen dieselbe Pruefung gefahren, die auch beim Buchen laeuft
 * (validatePayment mit genau der Vorbelegung, die der Dialog anbietet). Eine
 * eigene Liste hier waere die naechste Stelle, die bei einer Statusaenderung
 * vergessen wird — und ein Knopf, der beim Klick "geht nicht" sagt, ist
 * schlimmer als gar keiner.
 */
export const canMarkPaid = (invoice: Invoice, today: string): boolean => {
    const open = openAmountCents(invoice);
    if (open <= 0) return false;
    return !hasBlockingErrors(
        validatePayment(
            {
                direction: 'INCOMING',
                valueDate: today,
                amountCents: open,
                method: 'BANK_TRANSFER',
            },
            invoice,
            today,
        ),
    );
};
